export default __webpack_public_path__ + "static/media/skapaforkortning1.6fd45339.png";